<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据管理</el-breadcrumb-item>
      <el-breadcrumb-item>CT</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-container v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 1)">
        <el-header height="50">
          <el-row :gutter="20">
            <el-col :span="16">
              <el-slider
                v-model="value"
                show-input
                :min="minval"
                :max="maxval"
                @change="changeDicomSlice()"
              ></el-slider>
            </el-col>
            <el-col :span="8" style="margin-top:3px;">
              <el-button
                @click="windowBtnClick()"
                type="primary"
                size="small"
                plain
                >窗口</el-button
              >
              <el-button
                @click="zoomBtnClick()"
                type="primary"
                size="small"
                plain
                >缩放</el-button
              >
              <el-button
                @click="panBtnClick()"
                type="primary"
                size="small"
                plain
                >移动</el-button
              >
              <el-button
                @click="resetBtnClick()"
                type="primary"
                size="small"
                plain
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-header>
        <el-main>
          <div class="image-canvas-wrapper">
            <!-- DICOM CANVAS -->
            <div ref="canvas" class="image-canvas"></div>
          </div>
        </el-main>
      </el-container>
    </el-card>
  </div>
</template>

<script>
import * as cornerstone from "cornerstone-core";
import * as dicomParser from "dicom-parser";
import * as cornerstoneWADOImageLoader from "cornerstone-wado-image-loader";
import Hammer from "hammerjs";
import * as cornerstoneMath from "cornerstone-math";
import * as cornerstoneTools from "cornerstone-tools";
import * as nifti from "nifti-reader-js";

var config = {
  webWorkerPath: "/lib/cornerstoneWADOImageLoaderWebWorker.min.js",
  taskConfiguration: {
    decodeTask: {
      codecsPath: "/lib/cornerstoneWADOImageLoaderCodecs.min.js",
    },
  },
};
cornerstoneWADOImageLoader.webWorkerManager.initialize(config);
cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
cornerstoneWADOImageLoader.external.cornerstoneMath = cornerstoneMath;

export default {
  data() {
    return {
      dataid: 0,
      value: 0,
      minval: 0,
      maxval: 0,
      dicomlist: [],
      loading:true,
    };
  },
  methods: {
    async loadDicom() {
      cornerstone.enable(this.$refs.canvas);

      this.dataid = this.$route.query.id;
      const { data } = await this.$http.get("/getDicomUrls/" + this.dataid);
      let _this = this;
      if (data.status === 100) {
        this.dicomlist = data.data;
        this.maxval = this.dicomlist.length - 1;
        cornerstone.loadAndCacheImage("wadouri:" + this.dicomlist[this.value]).then(
          function(image) {
            cornerstone.displayImage(_this.$refs.canvas, image);
            _this.loading = false;
          }
        )
        
      }
      
    },
    resetBtnClick() {
      this.value = 0;
      this.changeDicomSlice();
      cornerstone.reset(this.$refs.canvas);
    },
    clearMouseDown() {
      this.$refs.canvas.removeEventListener(
        "mousedown",
        this.mouseDownAdjustWindow
      );
      this.$refs.canvas.removeEventListener("mousedown", this.mouseDownZoom);
      this.$refs.canvas.removeEventListener("mousedown", this.mouseDownPan);
    },
    zoomBtnClick() {
      this.clearMouseDown();
      this.$refs.canvas.addEventListener("mousedown", this.mouseDownZoom);
    },
    windowBtnClick() {
      this.clearMouseDown();
      this.$refs.canvas.addEventListener(
        "mousedown",
        this.mouseDownAdjustWindow
      );
    },
    panBtnClick() {
      this.clearMouseDown();
      this.$refs.canvas.addEventListener("mousedown", this.mouseDownPan);
    },
    mouseDownPan(e) {
      let lastX = e.pageX;
      let lastY = e.pageY;
      const _this = this;
      function mouseMoveHandler(e) {
        const deltaX = e.pageX - lastX;
        const deltaY = e.pageY - lastY;
        lastX = e.pageX;
        lastY = e.pageY;

        const viewport = cornerstone.getViewport(_this.$refs.canvas);
        viewport.translation.x += deltaX / viewport.scale;
        viewport.translation.y += deltaY / viewport.scale;
        cornerstone.setViewport(_this.$refs.canvas, viewport);
      }

      function mouseUpHandler() {
        document.removeEventListener("mousemove", mouseMoveHandler);
        document.removeEventListener("mouseup", mouseUpHandler);
      }

      document.addEventListener("mousemove", mouseMoveHandler);
      document.addEventListener("mouseup", mouseUpHandler);
    },
    mouseDownZoom(e) {
      const _this = this;
      let lastX = e.pageX;
      let lastY = e.pageY;

      function mouseMoveHandler(e) {
        const deltaX = e.pageX - lastX;
        const deltaY = e.pageY - lastY;
        lastX = e.pageX;
        lastY = e.pageY;

        let viewport = cornerstone.getViewport(_this.$refs.canvas);
        viewport.scale += deltaY / 100;
        cornerstone.setViewport(_this.$refs.canvas, viewport);
      }

      function mouseUpHandler() {
        document.removeEventListener("mouseup", mouseUpHandler);
        document.removeEventListener("mousemove", mouseMoveHandler);
      }

      document.addEventListener("mousemove", mouseMoveHandler);
      document.addEventListener("mouseup", mouseUpHandler);
    },
    mouseDownAdjustWindow(e) {
      let lastX = e.pageX;
      let lastY = e.pageY;
      let _this = this;
      function mouseMoveHandler(e) {
        const deltaX = e.pageX - lastX;
        const deltaY = e.pageY - lastY;
        lastX = e.pageX;
        lastY = e.pageY;

        let viewport = cornerstone.getViewport(_this.$refs.canvas);
        viewport.voi.windowWidth += deltaX / viewport.scale;
        viewport.voi.windowCenter += deltaY / viewport.scale;
        cornerstone.setViewport(_this.$refs.canvas, viewport);
      }

      function mouseUpHandler() {
        document.removeEventListener("mousemove", mouseMoveHandler);
        document.removeEventListener("mouseup", mouseUpHandler);
      }

      document.addEventListener("mousemove", mouseMoveHandler);
      document.addEventListener("mouseup", mouseUpHandler);
    },
    changeDicomSlice() {
      let _this = this;
      cornerstone
        .loadAndCacheImage("wadouri:" + this.dicomlist[this.value])
        .then(function (image) {
          cornerstone.displayImage(_this.$refs.canvas, image);
        });
    },
  },
  created() {
    
  },
  computed: {},
  mounted() {
    this.loadDicom();
  },
};
</script>

<style lang="less" scoped>
.image-canvas-wrapper {
  width: 100%;
  height: 512px;
  // margin: 0 auto;
}
.image-canvas {
  width: 100%;
  height: 100%;
}
</style>
